import React from "react";
import NewlyAddedStores from "./NewlyAdded";
import Slider from "./Slider";
import Deals from "./Deals";
import Newsletter from "./Newsletter";

function Index() {
  return (
    <div className="container" style={{backgroundColor: "#F3F4F6", paddingTop:"1px", 
    borderLeft:'15px solid #F3F4F6'}}>
      <Slider />
      <Deals />
      <NewlyAddedStores />
      <Newsletter></Newsletter>
    </div>
  );
}

export default Index;
